module.exports = __webpack_public_path__ + "static/media/Report_01-Jan-2025_to_31-Dec-2025.8e989d64.pdf";